import { setPrefix } from "../setPrefix"
import { getReadableValue } from "../selectOptions"
import { submissionStatusOptions } from "../selectOptions/shared/submission-status"
import { projectStatusOptions } from "../selectOptions/shared/project-status"
import { formatMoney } from "../formatMoney"

export const parseSubmissionDataToTrack = (submissionData, isProject) => {
  const submissionDataToParse = {
    id: submissionData?.id,
    nombre: submissionData?.name,
    montoSolicitado: formatMoney(submissionData?.approved),
    estatus: getReadableValue(isProject ? projectStatusOptions : submissionStatusOptions, submissionData?.status),
    region: submissionData?.region
  }

  const implementerDataToParse = {
    id: submissionData?.implementer?.id,
    nombre: submissionData?.implementer?.name
  }

  return {
    ...setPrefix(submissionDataToParse, "solicitud"),
    ...setPrefix(implementerDataToParse, "implementadora")
  }
}